import { z } from "zod";

export const IncidentTypeSchema = z.object({
  name: z.string(),
  description: z.string().optional(),
});

export const IncidentsTypeSchema = z.array(IncidentTypeSchema).default([
  { name: "Attendance", description: "Incident related to attendance issues." },
  { name: "Coaching", description: "Incident related to coaching or mentoring." },
  { name: "HR Related", description: "Incident involving human resources." },
  { name: "Positive Remark", description: "Incident involving positive feedback or remarks." },
  { name: "Client Issue", description: "Incident concerning client-related problems." },
  { name: "Referral Bonus", description: "Incident regarding referral bonuses." },
  { name: "Safety", description: "Incident concerning safety regulations or violations." },
  { name: "Termination Report", description: "Incident involving termination of employment." },
  { name: "Other", description: "Miscellaneous incidents not categorized above." },
]);
